import { useContext, useLayoutEffect, useMemo } from "react";
import { AbilityContext } from "@shared/lib/casl/ability-context";
import { Permissions, SubjectRule } from "@shared/lib/casl/types";
import { dedupeAbilities } from "./dedupe-abilities";

export function useUpdateAbility({
  permissions,
  abilityBuilder,
}: {
  permissions?: Permissions;
  abilityBuilder: (arg0: Permissions) => SubjectRule[];
}) {
  const ability = useContext(AbilityContext);

  const updatedAbility = useMemo(
    () => (permissions ? abilityBuilder(permissions) : []),
    [abilityBuilder, permissions],
  );

  // До отрисовки кадра: иначе <Can /> в ячейках таблицы успевает прочитать ability до update()
  useLayoutEffect(() => {
    if (!updatedAbility || updatedAbility.length === 0) return;

    // Подменяем права только для тех сущностей (subject),
    // для которых пришли новые permissions, не трогая остальные.
    const subjectsToUpdate = new Set(
      updatedAbility.map((rule) => rule.subject as string),
    );

    const preservedExistingRules =
      (ability.rules as SubjectRule[]).filter(
        (rule) => !subjectsToUpdate.has(rule.subject as string),
      ) || [];

    const mergedAbilities = dedupeAbilities([
      ...preservedExistingRules,
      ...updatedAbility,
    ]);

    // @ts-expect-error TODO: несовпадение типов rules/update в casl
    ability.update(mergedAbilities);
  }, [updatedAbility, ability]);
}
